<template>
  <transition name="fade" mode="out-in">
    <storeDefault v-if="template_name === 'yykmembership'" key="yykmembership"></storeDefault>
    <storeSport v-else-if="template_name === 'yykmendian'" key="yykmendian"></storeSport>
    <storeUniversal v-else-if="template_name === 'yykuniversal'" key="yykuniversal"></storeUniversal>
    <mallDefault v-else-if="template_name === 'yykweishop'" key="yykweishop"></mallDefault>
    <marketingCard v-else-if="template_name === 'marketingCard'" key="marketingCard"></marketingCard>
    <marketingGroup v-else-if="template_name === 'yykcutdown'" key="yykcutdown"></marketingGroup>
    <mallCommunity v-else-if="template_name === 'yykcommunity'" key="yykcommunity"></mallCommunity>
    <communityManagement v-else-if="template_name === 'yykcommunitypms'" key="yykcommunitypms"></communityManagement>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getWxaAuthList } from '../../api/wxa'
  // store
  import storeDefault from '@/view/wxapp/template/store/default'
  import storeSport from '@/view/wxapp/template/store/sport'
  import storeUniversal from '@/view/wxapp/template/store/universal'

  // mall
  import mallDefault from '@/view/wxapp/template/mall/default'
  import mallCommunity from '@/view/wxapp/template/mall/community'
  import communityManagement from '@/view/wxapp/template/mall/community_management'

  // marketing
  import marketingCard from '@/view/wxapp/template/marketing/card'
  import marketingGroup from '@/view/wxapp/template/marketing/group'

  export default {
    data() {
      return {
        currentCode: '',
        wxapps: [],
      }
    },
    components: {
      storeDefault: storeDefault,
      storeSport: storeSport,
      storeUniversal: storeUniversal,
      mallDefault: mallDefault,
      mallCommunity: mallCommunity,
      communityManagement: communityManagement,
      marketingCard: marketingCard,
      marketingGroup: marketingGroup
    },
    computed: {
      ...mapGetters([
        'wxapp_id',
        'template_name'
      ])
    },
    methods: {},
    mounted () {
      if (this.$route.query.wxappid !== undefined) {
        this.$store.dispatch('setWxappId', this.$route.query.wxappid)
      }
      if (this.$route.query.templatename) {
        this.$store.dispatch('setTemplateName', this.$route.query.templatename)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// management.vue?077f44e0